import { Button } from '@material-tailwind/react'

export default function DeleteMessageModel({ handleDeleteMessageCancel, handleDeleteMessageConfirm }) {
    return (
        <div className="absolute inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="bg-white h-auto py-4 dark:bg-gray-900 shadow-lg rounded-lg w-[300px] flex flex-col items-center justify-center">
                <p className="text-[24px] font-bold text-black dark:text-white text-center mb-2">
                    Delete Message
                </p>
                <p className="text-[12px] text-black px-4 dark:text-white text-center">
                    Are you sure you want to delete this message? This action cannot be undone.
                </p>
                <div className="flex gap-2 mt-4">
                    <Button
                        onClick={handleDeleteMessageCancel}
                        size="sm"
                        className="bg-[#1b1b1b] dark:bg-gray-400 dark:text-black dark:hover:bg-gray-500 hover:bg-[#0f0f0f] text-white"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleDeleteMessageConfirm}
                        size="sm"
                        className="bg-red-900 hover:bg-red-600 text-white"
                    >
                        Delete
                    </Button>
                </div>
            </div>
        </div>
    )
}
